<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-7 col-12 title-trends">Riesgos territoriales</div>
        <div class="col-sm-5 col-12">
            <div class="row justify-content-end">
                <a class="col-3" routerLink="../riesgo-global">
                    <img class="icon-trends" src="assets/img/t/tg-w.webp" alt="Riesgo global"></a>
                <a class="col-3" routerLink="../riesgo-territorial">
                    <img class="icon-trends" src="assets/img/t/tt-b.webp" alt="Riesgo territorial"></a>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <p class="col-12">Condiciones o <b>eventos potenciales</b> que, de ocurrir, tendrían un <b>impacto negativo</b>
            sobre el
            bienestar de la <b>población regional o el desarrollo territorial.</b> </p>
    </div>
    <!-- Start carousel -->
    <app-carousel [idTier1ForSlider]="idTier1"></app-carousel>
    <!-- End carousel -->
    <div class="row">
        <div class="col-md-12">
            <p class="py-4">Seleccione un territorio para explorar sus principales riesgos territoriales:</p>
        </div>
        <div class="col-12 col-sm-4 col-md-4 mt-2">
            <div class="map-ut"></div>
        </div>
        <ng-container *ngIf="t3Selected.length>0">
            <div class="col-12 col-sm-8 col-md-8">
                <div class="dpto-title">
                    <li>{{dptoNameSelected}}</li>
                </div>
                <div class="row btn-trend-m">
                    <div class="col-6 col-sm-6 col-elements" *ngFor="let p of t3Selected">
                        <!-- <div class="card-elements" routerLink="../ficha/{{p.code}}" [ngStyle]="{'border-color': color}"> -->
                        <div class="card-elements" routerLink="../ficha/{{p.code}}">
                            <div class="btn-trends">
                                <i class="fa fa-square fa-rotate-45" aria-hidden="true"></i>
                                <div class="box-text-btn">{{p.shorttitle}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="fichaGeo.length > 0; else noDocumentsMessage">
                    <hr>
                    <p *ngFor="let f of fichaGeo">Descargue el reporte completo
                        <a *ngIf="f.url.startsWith('http')" class="underline" href="{{f.url}}" target="_blank">aquí.</a>
                        <a *ngIf="f.url.startsWith('/uploads')" class="underline" href="{{URLObs}}{{f.url}}" target="_blank">aquí.</a>
                    </p>
                </ng-container>
                <ng-template #noDocumentsMessage>
                    <hr>
                    <p>Pronto se subirá este reporte territorial.</p>
                </ng-template>
            </div>
        </ng-container>
    </div>
</div>
